(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('VoceBilancioDeleteController',VoceBilancioDeleteController);

    VoceBilancioDeleteController.$inject = ['$uibModalInstance', 'entity', 'VoceBilancio'];

    function VoceBilancioDeleteController($uibModalInstance, entity, VoceBilancio) {
        var vm = this;

        vm.voceBilancio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VoceBilancio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
